import Common from "../../../../../../Common";

interface Body {
	pbx_account_id: id
}

const Account = class extends Common {
	browse = (
		companyId: id,
		profileTemplateId: id,
		profileTemplateProfileId: id,
		queueId: id
	) =>
		this.get(`/company/${companyId}/templates/profiles/${profileTemplateId}/profile/${profileTemplateProfileId}/queue/${queueId}/account`)

	create = (
		companyId: id,
		profileTemplateId: id,
		profileTemplateProfileId: id,
		queueId: id,
		body: Body
	) =>
		this.post(`/company/${companyId}/templates/profiles/${profileTemplateId}/profile/${profileTemplateProfileId}/queue/${queueId}/account`, body)

	delete = (
		companyId: id,
		profileTemplateId: id,
		profileTemplateProfileId: id,
		queueId: id,
		accountId: id
	) =>
		this.doDelete(`/company/${companyId}/templates/profiles/${profileTemplateId}/profile/${profileTemplateProfileId}/queue/${queueId}/account/${accountId}`)
}

export default Account
